import { CtaEvent } from './types';

export const getUnavailableVariant = ({
  travellerCount,
  maxOccupants,
}: {
  travellerCount: number | undefined | null;
  maxOccupants: number | undefined | null;
}): {
  unavailableText: string;
  ctaButtonText: string;
  ctaEvent: CtaEvent;
} => {
  if (travellerCount && maxOccupants && travellerCount > maxOccupants) {
    return {
      unavailableText:
        'This room cannot accommodate the selected number of travellers',
      ctaButtonText: 'Change travellers',
      ctaEvent: 'CHANGE_TRAVELLERS',
    };
  }
  return {
    unavailableText: 'This room is not available on the selected travel dates',
    ctaButtonText: 'Change dates',
    ctaEvent: 'CHANGE_DATES',
  };
};
